import { format, isValid } from "date-fns";
import { ptBR } from "date-fns/locale";

/**
 * Formata uma data com segurança — retorna `fallback` se o valor for nulo,
 * indefinido ou inválido (evita RangeError: Invalid time value).
 *
 * @param value  Timestamp (number), string de data ou Date
 * @param fmt    Padrão date-fns (ex: "dd/MM/yyyy HH:mm")
 * @param fallback  Texto exibido quando o valor é inválido (padrão: "—")
 */
export function safeFormat(value: unknown, fmt: string, fallback = "—"): string {
  if (value == null) return fallback;
  const d =
    value instanceof Date
      ? value
      : typeof value === "number"
      ? new Date(value)
      : new Date(String(value));
  return isValid(d) ? format(d, fmt, { locale: ptBR }) : fallback;
}
